<script lang="ts" setup>
import { EvaluationCriteriaConfiguration, EvaluationRelevantInstance, TokenData } from "types/EvaluationResults";

const props = defineProps({
  criteriaConfig: {
    type: Object as PropType<EvaluationCriteriaConfiguration>,
    required: true,
  },
  relevantInstance: {
    type: Object as PropType<EvaluationRelevantInstance>,
    required: true,
  },
  tokenData: {
    type: Object as PropType<TokenData[]>,
    required: false,
  },
  showTokenData: {
    type: Boolean,
    default: false,
  },
  showHiddenCriteria: {
    type: Boolean,
    default: false,
  },
  shouldShowInstances: {
    type: Boolean,
    default: false,
  },
});

const filteredCriteria = computed(() => {
  if (!props.relevantInstance.criteria) {
    return [];
  }

  return props.relevantInstance.criteria.filter((criteria) => {
    return criteria.config.isMechanics != true;
  });
});

const tokenDataText = computed(() => {
  if (!props.tokenData) {
    return "";
  }

  const token = props.tokenData.find((data) => {
    const matchingToken = props.relevantInstance.tokens.find(
      (relevantInstanceToken) => {
        return relevantInstanceToken.text == data.text;
      }
    );

    return matchingToken != undefined;
  });

  if (!token) {
    return "";
  }

  return `Dep: ${token.dep} | POS: ${token.pos} | Tag: ${token.tag} | Lemma: ${token.lemma}`;
});
</script>

<template>
  <div class="flex flex-col">
    <div
      class="flex flex-col"
      :class="{
        'bg-danger-default bg-opacity-10':
          relevantInstance.isUnexpected == true,
      }"
    >
      <span v-if="shouldShowInstances">
        <icon
          name="material-symbols:check-circle-rounded"
          class="text-success-default mr-2"
          v-if="relevantInstance.valid == true"
        />
        <icon
          name="mdi:close-circle"
          class="text-danger-default mr-2"
          v-if="relevantInstance.valid != true"
        />
        {{ relevantInstance.text }}- {{ relevantInstance.confidenceScore }}
      </span>
      <TransitionsCollapsible>
        <span v-if="showTokenData && tokenData">
          {{ tokenDataText }}
        </span>
      </TransitionsCollapsible>
    </div>
    <div
      class="flex flex-col"
      :class="{
        'ml-[16px] pl-2': showHiddenCriteria,
      }"
    >
      <DocumentProblemReviewTestingCriteriaItem
        v-for="(criteria, index) in filteredCriteria"
        :key="index"
        :criteria="criteria"
        :show-token-data="showTokenData"
        :show-hidden-criteria="showHiddenCriteria"
      />
    </div>
  </div>
</template>

<style scoped></style>
